export const money = (n) =>
  `RD$ ${Number(n || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const stripMarkdown = (text) => {
  if (!text) return text;
  return text
    .replace(/\*\*(.+?)\*\*/g, "$1")
    .replace(/__(.+?)__/g, "$1")
    .replace(/(?<!\*)\*(?!\*)(.+?)\*(?!\*)/g, "$1")
    .replace(/`(.+?)`/g, "$1")
    .replace(/^#{1,6}\s*/gm, "");
};

export const ORDER_STATES = [
  "borrador", "confirmado", "pago_pendiente", "pagado", "contra_entrega",
  "preparando", "despachado", "entregado", "cancelado",
];

export const ORDER_LABELS = {
  borrador: "Borrador",
  confirmado: "Confirmado",
  pago_pendiente: "Pago pendiente",
  pagado: "Pagado",
  contra_entrega: "Contra entrega",
  preparando: "Preparando",
  despachado: "Despachado",
  entregado: "Entregado",
  cancelado: "Cancelado",
};

export const ORDER_COLORS = {
  borrador: "bg-gray-100 text-gray-600",
  confirmado: "bg-blue-50 text-blue-600",
  pago_pendiente: "bg-amber-50 text-amber-600",
  pagado: "bg-emerald-50 text-emerald-600",
  contra_entrega: "bg-violet-50 text-violet-600",
  preparando: "bg-indigo-50 text-indigo-600",
  despachado: "bg-cyan-50 text-cyan-600",
  entregado: "bg-emerald-50 text-emerald-700",
  cancelado: "bg-red-50 text-red-600",
};

export const CHANNEL_LABELS = {
  simulador: "Simulador",
  whatsapp: "WhatsApp",
  instagram: "Instagram",
  web: "Web",
  shopify: "Shopify",
  manual: "Manual",
};

export const SHOPIFY_SYNC_LABELS = {
  no_publicado: "No publicado",
  pendiente: "Pendiente",
  sincronizado: "Sincronizado",
  error: "Error",
  eliminado_en_web: "Borrado en la web",
};

export const CONV_STATE_LABELS = {
  bot: "Agente IA",
  humano: "Humano",
  derivada: "Derivada",
};

export const FOLLOWUP_LABELS = {
  pendiente: "Pendiente",
  enviado: "Enviado",
  respondido: "Respondido",
  cancelado: "Cancelado",
  fallido: "Canal no disponible",
  requiere_plantilla: "Requiere plantilla",
  no_disponible_canal: "No disponible en el canal",
};

export const FOLLOWUP_COLORS = {
  pendiente: "bg-amber-50 text-amber-600",
  enviado: "bg-blue-50 text-blue-600",
  respondido: "bg-emerald-50 text-emerald-600",
  cancelado: "bg-gray-100 text-gray-500",
  fallido: "bg-red-50 text-red-600",
  requiere_plantilla: "bg-orange-50 text-orange-600",
  no_disponible_canal: "bg-gray-100 text-gray-500",
};

export const ENVIO_LABELS = {
  enviado: "Enviado", sent: "Enviado", delivered: "Entregado", read: "Leído",
  failed: "Falló el envío", sin_credenciales: "Sin credenciales", requiere_plantilla: "Requiere plantilla",
  no_disponible_canal: "No disponible en el canal", error: "Error al enviar",
};

export const CATALOG_ISSUE_LABELS = {
  sin_nombre: "Sin nombre",
  precio_invalido: "Precio inválido",
  stock_invalido: "Stock inválido",
  duplicado_en_archivo: "Duplicado en el archivo",
  sin_precio: "Sin precio",
  sin_sku: "Sin SKU",
  sku_ambiguo: "SKU en más de un producto del sistema",
  sku_repetido_web: "SKU repetido en la web",
  coincide_por_nombre: "Coincide solo por nombre",
  no_activo_en_web: "No está activo en la web",
};

// Qué cambiaría en un producto que ya existe (lista «cambios» de las filas que vienen de la web).
export const CATALOG_CAMBIO_LABELS = {
  nuevo: "Producto nuevo",
  nombre: "Nombre",
  descripcion: "Descripción",
  categoria: "Categoría",
  marca: "Marca",
  precio: "Precio",
  etiquetas: "Etiquetas",
  activo: "Activo o inactivo",
  sku: "SKU",
  vinculo: "Vínculo con la web",
  foto: "Foto",
  stock: "Stock",
};

// Por qué una fila se relaciona con un producto del sistema.
export const CATALOG_MATCH_LABELS = {
  variante: "ya vinculado con la web",
  sku: "mismo SKU",
  nombre: "mismo nombre",
  elegido: "elegido a mano",
};

// Avisos del archivo de Shopify, en minúscula para leerse dentro de una frase («12 sin precio»).
export const CSV_AVISO_LABELS = {
  no_activo: "no activos (no se importan)",
  stock_negativo: "con cantidad negativa (se toma como 0)",
  sin_precio: "sin precio",
  sin_sku: "sin SKU (se vincula por nombre)",
  sku_repetido: "con SKU repetido",
  sin_variantes: "sin datos de variante (no se importan)",
};

export const PAYMENT_LINK_LABELS = {
  pendiente: "Pendiente",
  pagado: "Pagado",
  rechazado: "Rechazado",
  vencido: "Vencido",
  anulado: "Anulado",
};

export const PAYMENT_LINK_COLORS = {
  pendiente: "bg-amber-50 text-amber-600",
  pagado: "bg-emerald-50 text-emerald-600",
  rechazado: "bg-red-50 text-red-600",
  vencido: "bg-gray-100 text-gray-500",
  anulado: "bg-gray-100 text-gray-500",
};

export const INVOICE_LABELS = {
  pendiente: "Pendiente",
  emitida: "Emitida",
  error: "Error",
  anulada: "Anulada",
};

export const INVOICE_COLORS = {
  pendiente: "bg-amber-50 text-amber-600",
  emitida: "bg-emerald-50 text-emerald-600",
  error: "bg-red-50 text-red-600",
  anulada: "bg-gray-100 text-gray-500",
};

export const TIPO_COMPROBANTE_LABELS = {
  consumo_final: "Consumo final (B02/E32)",
  credito_fiscal: "Crédito fiscal (B01/E31)",
};

export const dt = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("es-DO", {
      timeZone: "America/Santo_Domingo",
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const timeOnly = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString("es-DO", {
      timeZone: "America/Santo_Domingo", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return "";
  }
};

export const relTime = (iso) => {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const diffSec = Math.round((Date.now() - then) / 1000);
  if (diffSec < 30) return "ahora";
  if (diffSec < 60) return `hace ${diffSec}s`;
  const diffMin = Math.round(diffSec / 60);
  if (diffMin < 60) return `hace ${diffMin} min`;
  const diffHr = Math.round(diffMin / 60);
  if (diffHr < 24) return `hace ${diffHr} h`;
  const diffDay = Math.round(diffHr / 24);
  if (diffDay < 7) return `hace ${diffDay} d`;
  return dt(iso);
};

export const contactAlias = (c) => {
  if (c?.contacto_nombre && c.contacto_nombre.trim() && c.contacto_nombre !== "Cliente") return c.contacto_nombre;
  const shortId = (c?.id || "").slice(-4);
  return shortId ? `Cliente #${shortId}` : "Cliente";
};
